import React, { useEffect } from "react";
import { Marker, useMarkerRef } from "@vis.gl/react-google-maps/dist/index.umd.js";

const Marcador = ({ position, url, onClick, onMouseOver, clusterer, title, visible }) => {
  const [markerRef, marker] = useMarkerRef();

  useEffect(() => {
    if (!clusterer || !marker) {
      return undefined;
    }

    clusterer.addMarker(marker);

    return () => {
      clusterer.removeMarker(marker);
    };
  }, [clusterer, marker]);

  return (
    <Marker
      ref={markerRef}
      position={{ lat: position.lat, lng: position.lng }}
      title={title ? "" + title : undefined}
      visible={visible}
      icon={{
        url,
        scaledSize: { height: 32, width: 32 },
      }}
      onClick={onClick}
      onMouseOver={onMouseOver}
    />
  );
};

const diffToMemoize = (prevProps, nextProps) => {
  const position = prevProps.position === nextProps.position;
  const url = prevProps.url === nextProps.url;
  const visible = prevProps.visible === nextProps.visible;
  return (position && url && visible);
};

export default React.memo(Marcador, diffToMemoize);
